import Layout from '@/layout';
// 动态
export default {
    path: '/dynamic',
    name: 'Dynamic',
    component: Layout,
    redirect: '/dynamic/index',
    meta: {
        modules: [9000]
    },
    children: [
        {
            path: 'index',
            name: 'DynamicIndex',
            hidden: false,
            component: () => import('@/views/dynamic/index'),
            meta: {
                icon: 'menu_dt',
                title: '待办事项',
                modules: [9000]
            }
        }
    ]
};
